var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.875 17.5C1.875 17.1549 2.15482 16.875 2.5 16.875H17.5C17.8452 16.875 18.125 17.1549 18.125 17.5C18.125 17.8452 17.8452 18.125 17.5 18.125H2.5C2.15482 18.125 1.875 17.8452 1.875 17.5Z",
    fill: "#9897A6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1086 7.06673C17.3527 6.82265 17.3527 6.42693 17.1086 6.18285L12.9838 2.05806C12.7397 1.81398 12.344 1.81398 12.0999 2.05806L5.07074 9.08725C4.79725 9.36074 4.64361 9.73167 4.64361 10.1184L4.64361 13.8981C4.64361 14.2432 4.92343 14.5231 5.26861 14.5231L9.04822 14.5231C9.43499 14.5231 9.80593 14.3694 10.0794 14.0959L17.1086 7.06673ZM15.7828 6.62479L14.3096 8.09793L11.0687 4.85702L12.5419 3.38388L15.7828 6.62479ZM10.1849 5.74091L13.4258 8.98181L9.19553 13.212C9.15646 13.2511 9.10347 13.2731 9.04822 13.2731L5.89361 13.2731L5.89361 10.1184C5.89361 10.0632 5.91556 10.0102 5.95463 9.97113L10.1849 5.74091Z",
    fill: "#9897A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditTable);
export default __webpack_public_path__ + "static/media/edit-table.246ba4252d8920c458983ad298d9e928.svg";
export { ForwardRef as ReactComponent };